module.exports = __webpack_public_path__ + "img/JDapprovalblue.23e33be6.svg";